// extracted by mini-css-extract-plugin
export default {"buttonIsland":"Form_buttonIsland__TQK-J","formTitle":"Form_formTitle__v7wkq"};